import { TDateISOString } from '@core/helpers';

export interface IPtmSignerErrorMessageDTO {
  code?: string;
  message?: string;
}

export interface IPtmSignerCertificateValidationDTO {
  cert: boolean;
  token: boolean;
  token_expiration: TDateISOString | null;
  qr_code_url: string | null;
  error_message: IPtmSignerErrorMessageDTO[] | null;
}

export interface IPtmSignerCertificateValidation {
  cert: boolean;
  token: boolean;
  tokenExpiration: TDateISOString | null;
  qrCodeUrl: string | null;
}

export class PtmSignerCertificateValidationViewModelFactory {
  static create(dto: IPtmSignerCertificateValidationDTO): IPtmSignerCertificateValidation {
    return {
      cert: dto.cert,
      token: dto.token,
      tokenExpiration: dto.token_expiration,
      qrCodeUrl: dto.qr_code_url,
    };
  }
}

export interface IPtmSignerQrCodeValidationDTO {
  signer_checked: boolean;
  error_message: IPtmSignerErrorMessageDTO[] | null;
}

export interface IPtmSignerQrCodeValidation {
  signerChecked: boolean;
}

export class PtmSignerQrCodeValidationViewModelFactory {
  static create(dto: IPtmSignerQrCodeValidationDTO): IPtmSignerQrCodeValidation {
    return {
      signerChecked: dto.signer_checked,
    };
  }
}
